function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 31,
  cy: 31,
  r: 30,
  stroke: "#59C18D",
  strokeWidth: 2
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.3634 37.9874L20.7178 32.745C20.2496 32.3104 20.2635 31.5652 20.7475 31.1482C21.172 30.7826 21.8066 30.8057 22.2033 31.2013L26.33 35.3162C27.5286 36.5114 29.478 36.4789 30.6361 35.2445L43.3414 21.702C43.7108 21.3083 44.3236 21.272 44.7368 21.6195C45.1875 21.9984 45.223 22.6797 44.8142 23.1033L30.5636 37.8721C29.4287 39.0483 27.5611 39.0996 26.3634 37.9874Z",
  fill: "#59C18D"
});

var SvgCircleOk = function SvgCircleOk(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCircleOk, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/circle-ok.d76e53f8.svg";
export { ForwardRef as ReactComponent };